import type { GdsOfferingsResponse } from '../api-types/graphdatascience';
import { type Builder } from './types';

export const graphDataScienceEndpoints = (builder: Builder) => ({
  getGdsOfferings: builder.query<GdsOfferingsResponse, void>({
    query: () => `graphdatascience/sizes`,
  }),
});
